import { Position } from "../../../config/interactive/types";
import { mapPosToStyle } from "../utils";
import styles from "./interactiveComponent.module.css";

type props = {
	position: Position;
	src: string;
	hoveredSrc: string;
	isFocused: boolean;
};

export default function IconToggleOnFocus({ position, src, hoveredSrc, isFocused }: props) {
	const iconSrc = isFocused ? hoveredSrc : src;
	return (
		<div className={styles.iconContainer} style={mapPosToStyle(position)}>
			<img className={styles.icon} src={iconSrc}></img>
		</div>
	);
}
